import React from "react";

const BLUE = "#3455D3";
const PURPLE = "#8b5cf6";
const CYAN = "#60a5fa";

export function OrbitalDots({ size = 44 }: { size?: number }) {
  const id = React.useId();
  const dotCount = 12;
  const r = size * 0.38;
  const dotR = Math.max(2, size * 0.055);

  return (
    <>
      <style>{`
        @keyframes odots-spin-${id} {
          0%    { transform: rotate(0deg); }
          12%   { transform: rotate(460deg); }
          25%   { transform: rotate(690deg); }
          37%   { transform: rotate(1150deg); }
          50%   { transform: rotate(1440deg); }
          62%   { transform: rotate(1800deg); }
          75%   { transform: rotate(2110deg); }
          87%   { transform: rotate(2550deg); }
          100%  { transform: rotate(2880deg); }
        }
        @keyframes odots-hue-${id} {
          0%   { fill: ${CYAN}; }
          33%  { fill: ${BLUE}; }
          66%  { fill: ${PURPLE}; }
          100% { fill: ${CYAN}; }
        }
      `}</style>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}
        style={{ animation: `odots-spin-${id} 16s linear infinite` }}>
        {Array.from({ length: dotCount }).map((_, i) => {
          const angle = (i / dotCount) * 2 * Math.PI - Math.PI / 2;
          const cx = size / 2 + r * Math.cos(angle);
          const cy = size / 2 + r * Math.sin(angle);
          const opacity = 0.15 + (i / dotCount) * 0.85;
          const scale = 0.5 + (i / dotCount) * 0.5;
          const colorDelay = -(i / dotCount) * 3;
          return (
            <circle key={i} cx={cx} cy={cy} r={dotR * scale}
              fill={CYAN} opacity={opacity}
              style={{ animation: `odots-hue-${id} 3s linear ${colorDelay}s infinite` }} />
          );
        })}
      </svg>
    </>
  );
}
